import { render, staticRenderFns } from "./residenceAdditional.vue?vue&type=template&id=cc9fc290&scoped=true&"
import script from "./residenceAdditional.vue?vue&type=script&lang=js&"
export * from "./residenceAdditional.vue?vue&type=script&lang=js&"
import style0 from "./residenceAdditional.vue?vue&type=style&index=0&id=cc9fc290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9fc290",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VDialog,VRow,VSnackbar})
